import { DesktopActions } from '@store/desktop/desktop.action';
import {
  notificationAddError,
  notificationAddPending,
  notificationAddSuccess,
  resetNotification,
} from '@store/notificationWindow/notificationWindow.action';
import { getNotificationState } from '@store/notificationWindow/notificationWindow.selector';
import { State } from '@store/reducer';
import { ConnectedProps, connect } from 'react-redux';

export type NotificationWindowReduxProps = ConnectedProps<typeof notificationWindowConnector>;

const mapStateToProps = (state: State) => getNotificationState(state);

export const notificationWindowConnector = connect(mapStateToProps, {
  resetNotification,
  notificationAddPending,
  notificationAddSuccess,
  notificationAddError,
  showOutboxErrorFolder: DesktopActions.showOutboxErrorFolder,
});
